import styled from 'styled-components'
import { Button } from '@/ui/LegacyButton'
import { DefaultButtonProps } from './types'

export const TextButton = (props: DefaultButtonProps) => {
  return <TextButtonStyled {...props} />
}

const TextButtonStyled = styled(Button)`
  align-items: center;
  background-color: red;
  height: 36px;
  padding: 0 18px;
  text-align: center;
  border-radius: 10px;
`
